import { useMutation } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

import { EMAIL_VALIDATION_REG_EX } from "~/helpers/helpers";

import { SiteDeveloperInstructions } from "../../../../api/Api";
import { apiClient } from "../../../../api/ApiClient";
import labels from "../../../../helpers/labels";
import FormLabel from "../../../login/formLabel/FormLabel";
import Input from "../../../ui/input/Input";
import TextArea from "../../../ui/textArea/TextArea";
import styles from "./ContactDeveloper.module.scss";

type ContactDeveloperProps = {
  newSiteId: number;
  handleClose: () => void;
};

const ContactDeveloper = ({
  newSiteId,
  handleClose,
}: ContactDeveloperProps) => {
  const { mutate } = useMutation({
    mutationFn: async (data: SiteDeveloperInstructions) => {
      return await apiClient.sites.developerInstructionsCreate(newSiteId, data);
    },
    onSuccess: async () => {
      enqueueSnackbar("Email was sent successfully", {
        variant: "success",
      });
      handleClose();
    },
    onError: async (error) => {
      //@ts-expect-error fix when api added
      enqueueSnackbar(error?.error?.error, {
        variant: "error",
        persist: true,
      });
    },
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<SiteDeveloperInstructions>();

  const onSubmit = (data: SiteDeveloperInstructions) => {
    mutate(data);
    reset();
  };

  return (
    <div>
      <div className={styles.contactDevFormText}>
        Don`t feel confident about installing the code yourself? We can send an
        email to your developer so they can take care of the technical work to
        integrate our JavaScript Widget.
      </div>
      <div className={styles.contactDevFormText}>
        Don`t have a developer? <Link to="#">Let us handle</Link>
      </div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={styles.contactDevForm}
        id="contactDeveloper"
      >
        <FormLabel label="Email" />
        <Input
          errormessage={
            errors.email
              ? errors.email.message || labels.THIS_FIELD_CANNOT_BE_EMPTY
              : ""
          }
          {...register("email", {
            required: true,
            pattern: {
              value: EMAIL_VALIDATION_REG_EX,
              message: labels.INVALID_EMAIL,
            },
          })}
        />
        <FormLabel label="Message (optional)" />
        <TextArea minRows={6} {...register("message")} />
      </form>
    </div>
  );
};
export default ContactDeveloper;
